module.exports = __webpack_public_path__ + "static/media/plaque_sapin_2019.6ddeb209.png";